import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import {
    configurationElement, getCustomValueOption,
    getSubForm, getValidator, getValidatorFormField, isPointerConfigurationElement, typeDatabase,
    typeFormValue
} from "../../../configurationProperty/configurationPropertyUtils";
import { dataForm } from "../../../widget/auto-complete-form/auto-complete-form.component";
import {
    aggregateHardawareDetailDevice,
    arrayIsSet,
    isNotNullOrUndefined, NOTDEFINEDVALUE
} from "../../../providers/service/global-variables.service";
import { ElementParse } from "../../../ParseClass/Element.Parse";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { EMPTY, Subscription } from "rxjs";
import { htmlData, htmlFormElement } from "../../../pages/management-elements/elements-page/elements-page.component";
import { ElementPageService } from "../../../providers/service/element-page.service";
import { PossibleCommandsComponent } from "../possible-commands/possible-commands.component";
import { switchMap } from "rxjs/operators";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";

export type AutocompleteUpdateElementValueType = { environment?: string[], floor?: string[], room?: string[], }
export type KeysAutocompleteUpedateElementValueType = keyof AutocompleteUpdateElementValueType

@Component({
    selector: 'app-update-element',
    templateUrl: './update-element.component.html',
    styleUrls: ['./update-element.component.scss'],
    standalone: false
})
export class UpdateElementComponent implements OnInit, OnDestroy {
    @Output() clickSave = new EventEmitter();

    loading = { allElements: false }

    public htmlData: htmlData[] = [];
    public configElementSubForm: { element: configurationElement, htmlFormElement: htmlFormElement }[] = [];
    public subscriptionsKeyWithSubForm: Subscription[] = [];
    public form: UntypedFormGroup | undefined;
    sectionNumberName: { [k: string]: string } = { "0": 'features' }
    visualizedInTabGroup = true;
    public elements: ElementParse[] = [];
    private customFormSubscriptions: Subscription[] = [];

    private componentCustomValue: any = { possibleCommands: PossibleCommandsComponent }

    get element(): ElementParse {
        return this.data.element
    }

    get disableForm() {
        return this.data.disableForm
    }

    get possibleValuesPointer() {
        return this.data.possibleValuesPointer
    }
    get isBatchEdit() {
        return this.data.isBatchEdit
    }
    getPossibleValuesPointerByKey(keyName: string): any[] {
        return this.possibleValuesPointer && arrayIsSet(this.possibleValuesPointer[keyName]) ? this.possibleValuesPointer[keyName] : []
    }


    get possibleValuesExisistingField(): AutocompleteUpdateElementValueType {
        return this.data.possibleValuesExisistingField
    }

    getPossibleValuesExisistingField(keyName: string) {
        // return this.possibleValuesExisistingField && arrayIsSet(this.possibleValuesExisistingField[keyName]) ? this.possibleValuesExisistingField[keyName] as string[] : []
    }
    title: string | undefined = this.data.title != null ? this.data.title : undefined;
    constructor(
        public dialogRef: MatDialogRef<UpdateElementComponent>,
        @Inject(MAT_DIALOG_DATA) public data: {
            element: ElementParse,
            disableForm: boolean,
            possibleValuesPointer: { [k: string]: any[] },
            possibleValuesExisistingField: AutocompleteUpdateElementValueType,
            isBatchEdit: boolean,
            title?: string

        },
        private elementPageService: ElementPageService,
        private fb: UntypedFormBuilder,
        private matDialog: MatDialog) {
    }


    disableAllKeyInForm() {
        Object.keys(this.form?.value).forEach(key => {
            if (this.form?.get(key)) {
                this.form?.get(key)?.disable({ emitEvent: false })
            }
        })
        this.form?.updateValueAndValidity()
    }

    ngOnInit(): void {
        this.composeForm(this.element, this.disableForm)
    }

    ngOnDestroy(): void {
        this.customFormSubscriptions.forEach(sub => sub.unsubscribe());
        this.subscriptionsKeyWithSubForm.forEach(sub => sub.unsubscribe())
    }

    private addHtmlElement(element: configurationElement, htmlFormElement: htmlFormElement, htmlData: htmlData[]): void {
        const key = element.section.toString()
        const tabGroupName = this.sectionNumberName.hasOwnProperty(key) ? this.sectionNumberName[key] : 'null';
        const index = htmlData.findIndex(htmlValue => htmlValue.tabGroupName === tabGroupName)
        if (index >= 0) {
            htmlData[index].forms.push(htmlFormElement)
        } else {
            htmlData.push({ tabGroupName: tabGroupName, forms: [htmlFormElement] })
        }
    }


    private getPossibleValuesCurrentValue(possibleValues: string[], cValue: string, traductionKey: string): {
        possibleValues: dataForm[] | undefined,
        currentValue: string | undefined
    } {
        let currentValue;
        if (arrayIsSet(possibleValues)) {
            const pValues = possibleValues.map((possibleValue, index) => {
                const keyForm = possibleValue;
                if (possibleValue == cValue) {
                    currentValue = keyForm
                }
                const obj = {
                    valueForm: keyForm,
                    html: keyForm,
                    traduction: keyForm.toString(),
                }
                return obj
            })
            const index = pValues.findIndex((value) => value.valueForm == cValue)
            if (index < 0 && cValue != null) {
                pValues.push({ valueForm: cValue, html: cValue, traduction: cValue })
                currentValue = cValue;
            }
            return { possibleValues: pValues, currentValue }
        } else {
            return { possibleValues: undefined, currentValue: cValue }
        }
    }

    private getPossibleValuePointer(keyname: string, currentValue: any): {
        possibleValues: dataForm[] | undefined,
        currentValue: string | undefined
    } {
        if (arrayIsSet(this.getPossibleValuesPointerByKey(keyname))) {
            let cValue
            const pValues = this.possibleValuesPointer[keyname].map(possibleValue => {
                if (currentValue != null && possibleValue.objectId == currentValue.objectId) {
                    cValue = possibleValue.objectId
                }
                const obj: dataForm = {
                    valueForm: possibleValue.objectId,
                    html: possibleValue.objectId,
                    traduction: this.elementPageService.getTraduction(keyname, possibleValue)
                }
                return obj
            })
            return { possibleValues: pValues, currentValue: cValue }
        } else {
            return { possibleValues: undefined, currentValue: currentValue }
        }
    }


    private getFormGroupChild(element: configurationElement, detail: ElementParse | undefined, referenceKey: string): {
        formGroupChild: { formGroupName: string | undefined, fields: any[] | undefined } | undefined,
        subObjForm: { key: string, formGroup: UntypedFormGroup } | undefined
    } {
        const subForm = getSubForm(element, referenceKey)
        let formGroupChild: { formGroupName: string | undefined, fields: any[] | undefined };
        let formGroup;
        if (arrayIsSet(subForm)) {
            const subObjForm: { [k: string]: any } = {};
            const key = element.forms?.databaseKey! as keyof ElementParse
            const subDetail = detail != null && isNotNullOrUndefined(detail[key]) ? detail[key] : {};
            const subHtml: {
                type: typeFormValue,
                possibleValues: dataForm[] | undefined,
                formControlName: string,
                traduction: string
            }[] = [];
            subForm
                .sort((aValue, bValue) => aValue.sortingValue - bValue.sortingValue)
                .forEach(subElement => {
                    const pValueCurrent = this.getPossibleValuesCurrentValue(subElement.possibleValues!, subDetail[subElement.keyName], subElement.keyTraduction)
                    subObjForm[subElement.keyName] = [{
                        disabled: !element.editable,
                        value: pValueCurrent.currentValue,
                    }, getValidatorFormField(subElement)]
                    const subForm = {
                        type: subElement.typeForm,
                        possibleValues: pValueCurrent.possibleValues,
                        formControlName: subElement.keyName,
                        traduction: subElement.keyTraduction
                    }
                    subHtml.push(subForm);
                })
            formGroupChild = { formGroupName: undefined, fields: undefined };
            formGroupChild.formGroupName = element.forms?.databaseKey!;
            formGroupChild.fields = subHtml as any[];
            formGroup = this.fb.group(subObjForm)
            return { formGroupChild, subObjForm: { key: element.forms?.databaseKey!, formGroup: formGroup } };
        } else {
            return { formGroupChild: undefined, subObjForm: undefined }
        }
    }

    getFormHtmlData(configurationData: configurationElement[], detail: ElementParse): {
        formGruop: UntypedFormGroup,
        htmlData: htmlData[],
        configElementSubForm: { element: configurationElement, htmlFormElement: htmlFormElement }[]
    } {
        const html: htmlData[] = [];
        const objForm: { [k: string]: any } = {};
        const configElementSubForm: any[] = [];
        configurationData
            .filter(element => this.data.isBatchEdit ? element.batchEdit == true : element.showInForm == true)
            .forEach(element => {
                let possibleValues;
                let valueForm;
                const keyName = element.keyName as keyof ElementParse
                if (element.typeForm == typeFormValue.GEO_POINT) {
                    if (detail[keyName] != null) {
                        valueForm = { latitude: detail[keyName].latitude, longitude: detail[keyName].longitude };
                    }
                } else if (isPointerConfigurationElement(element)) {
                    const pValueCurrent = this.getPossibleValuePointer(keyName, detail[keyName])
                    possibleValues = pValueCurrent.possibleValues
                    valueForm = pValueCurrent.currentValue
                } else if (arrayIsSet(element.possibleValues)) {
                    const pValueCurrent = this.getPossibleValuesCurrentValue(element.possibleValues, detail[keyName], element.traductionKey)
                    possibleValues = pValueCurrent.possibleValues
                    valueForm = pValueCurrent.currentValue
                } else if (element.possibleValueIsInVariableComponent) {
                    const existingPValues: string[] = this.possibleValuesExisistingField[element.keyName as KeysAutocompleteUpedateElementValueType] as string[];
                    const currentValue = detail[keyName] == NOTDEFINEDVALUE.environment ? undefined : detail[keyName]
                    const pValueCurrent = this.getPossibleValuesCurrentValue(existingPValues, currentValue, element.traductionKey)
                    possibleValues = arrayIsSet(pValueCurrent.possibleValues) ? pValueCurrent.possibleValues : []
                    valueForm = pValueCurrent.currentValue
                } else {
                    valueForm = detail[keyName]
                }
                const htmlFormElement: htmlFormElement = {
                    type: element.typeForm,
                    possibleValues: possibleValues,
                    formControlName: element.keyName,
                    traduction: element.traductionKey,
                    formGroupChild: undefined
                };
                objForm[element.keyName] = [{
                    value: valueForm,
                    disabled: !element.editable
                }, getValidator(element)]

                const subFormValue = this.getFormGroupChild(element, detail, detail[keyName])
                if (isNotNullOrUndefined(subFormValue.formGroupChild)) {
                    htmlFormElement.formGroupChild = subFormValue.formGroupChild as any;
                    objForm[subFormValue.subObjForm?.key!] = subFormValue.subObjForm?.formGroup;
                    configElementSubForm.push({ element: element, htmlFormElement: htmlFormElement })
                }
                this.addHtmlElement(element, htmlFormElement, html);

            })
        return { formGruop: this.fb.group(objForm), htmlData: html, configElementSubForm };
    }

    addControlFormGruopCustomValue(form: UntypedFormGroup, configurationData: configurationElement[]) {
        this.customFormSubscriptions.forEach(sub => sub.unsubscribe());

        getCustomValueOption(configurationData).forEach(element => {
            const validators = getValidator(element)
            form.addControl(element.keyName, this.fb.control(null));
            if (Array.isArray(validators) && arrayIsSet(validators)) {
                validators.forEach(validator => {
                    form.setValidators(validator)
                })
            }

            form.get(element.keyName)?.setValue({ click: false, values: [] });
            if (this.componentCustomValue[element.keyName] != null) {
                const sub = form.get(element.keyName)?.valueChanges
                    .pipe(
                        switchMap((val) => {
                            if (val && val.click) {
                                const value = this.form?.get(element.keyName)?.value
                                return this.matDialog.open(this.componentCustomValue[element.keyName], {
                                    data: { currentValue: value },
                                    minWidth: '300px',
                                    autoFocus: false,
                                    exitAnimationDuration: 0.1
                                }).afterClosed()
                            } else {
                                return EMPTY
                            }
                        })
                    )
                    .subscribe(val => {
                        if (arrayIsSet(val)) {
                            this.form?.get(element.keyName)?.setValue({ click: false, values: val })
                        }
                    })
                if (sub instanceof Subscription) {
                    this.customFormSubscriptions.push(sub);
                }
            }

        })
    }

    public composeForm(detail: ElementParse, disableForm: boolean) {
        this.htmlData = [];
        this.form = undefined;
        this.configElementSubForm = [];
        setTimeout(() => {
            const configurationData = this.elementPageService.getConfigurationByProject()
                .sort((aValue, bValue) => aValue.sortingValue - bValue.sortingValue);
            const valueFormHtml = this.getFormHtmlData(configurationData, detail)
            this.form = valueFormHtml.formGruop;
            this.addControlFormGruopCustomValue(this.form, configurationData)

            this.htmlData = valueFormHtml.htmlData;
            if (this.htmlData.length > 1) {
                this.visualizedInTabGroup = true
            } else {
                this.visualizedInTabGroup = false
            }
            this.configElementSubForm = valueFormHtml.configElementSubForm;
            this.configElementSubForm.forEach(elementHtml => {
                const keyname = elementHtml.element.keyName
                const subScription = this.form?.get(keyname)?.valueChanges.subscribe(
                    changeValue => {
                        elementHtml.htmlFormElement.formGroupChild = this.getFormGroupChild(elementHtml.element, undefined, changeValue).formGroupChild as any
                    })
                if (subScription instanceof Subscription) {
                    this.subscriptionsKeyWithSubForm.push(subScription)
                }
            })
            if (disableForm) {
                this.disableAllKeyInForm();
            }
        })
    }

    clickSaveButton() {
        const values: { [k: string]: any } = {}
        Object.keys(this.form?.value).forEach(key => {
            if (!this.form?.get(key)?.pristine) {
                let valueSet = this.form?.get(key)?.value;
                if (arrayIsSet(this.getPossibleValuesPointerByKey(key))) {
                    const index = this.getPossibleValuesPointerByKey(key).findIndex(value => value.objectId == valueSet)
                    if (index >= 0) {
                        valueSet = this.getPossibleValuesPointerByKey(key)[index]
                    }
                }
                const elType = this.elementPageService.configuration.find(el => el.keyName == key);
                if (elType != null && valueSet != null) {
                    const type = elType.typeDatabase;
                    if (typeof valueSet != "string" && type == typeDatabase.STRING) {
                        valueSet = valueSet.toString();
                    } else if (typeof valueSet != "number" && type == typeDatabase.NUMBER) {
                        valueSet = parseFloat(valueSet);
                    }
                }
                values[key] = valueSet;
            }
        })

        this.dialogRef.close(values)

    }

}
